//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('priceListBusCo', {
//        templateUrl: 'views/components/views/priceListBusCo/priceListBusCo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'priceListBusCoService', function ($stateParams, stateService, priceListBusCoService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let priceListId = $stateParams.pricelist_id;
//            let businessCoNo = $stateParams.businessco_no;
            
//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await priceListBusCoService.getEdit({
//                    pricelist_id: priceListId,
//                    businessco_no: businessCoNo
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region SAVE BUTTON FUNCTION

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;
                
//                priceListBusCoService.saveObj(vm.model.edit).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion SAVE BUTTON FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
